import React from 'react';
import { motion } from 'framer-motion';
import { Youtube, Facebook, Instagram, Music2, ExternalLink } from 'lucide-react';
import { contactInfo } from '../data/mock';

const SocialBanner = () => {
  const socialLinks = [
    {
      name: 'YouTube',
      url: contactInfo.socials.youtube,
      icon: Youtube,
      color: '#FF0000',
      handle: '@LoxitonDeepHouse'
    },
    {
      name: 'Facebook',
      url: contactInfo.socials.facebook,
      icon: Facebook,
      color: '#1877F2',
      handle: 'LoxitonDeepHouse'
    },
    {
      name: 'Instagram',
      url: contactInfo.socials.instagram,
      icon: Instagram,
      color: '#E4405F',
      handle: '@LoxitonDeepHouse'
    },
    {
      name: 'TikTok',
      url: contactInfo.socials.tiktok,
      icon: null, // Custom SVG
      color: '#000000',
      handle: '@LoxitonDeepHouse'
    },
    {
      name: 'Audiomack',
      url: contactInfo.socials.audiomack,
      icon: Music2,
      color: '#FFA500',
      handle: 'morena-thedeejay'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-r from-mid-purple via-light-pink to-mid-blue">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10"
        >
          <h2 className="font-display text-3xl md:text-4xl font-extrabold text-black uppercase mb-3">
            Follow Us on Social Media
          </h2>
          <p className="text-black/70 text-lg max-w-2xl mx-auto">
            Stay updated on the <span className="font-bold">R50,000 Recording Contract</span> giveaway and exclusive content!
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="grid grid-cols-2 md:grid-cols-5 gap-4"
        >
          {socialLinks.map((social, index) => (
            <motion.a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              whileHover={{ scale: 1.05, y: -5 }}
              className="bg-white rounded-xl p-6 text-center shadow-lg hover:shadow-xl transition-shadow group"
            >
              <div 
                className="w-14 h-14 rounded-full mx-auto mb-4 flex items-center justify-center transition-colors"
                style={{ backgroundColor: `${social.color}20` }}
              >
                {social.icon ? (
                  <social.icon 
                    className="w-7 h-7 transition-colors" 
                    style={{ color: social.color }}
                  />
                ) : (
                  <svg 
                    className="w-7 h-7" 
                    viewBox="0 0 24 24" 
                    fill={social.color}
                  >
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                  </svg>
                )}
              </div>
              <h3 className="font-display text-lg font-bold text-black uppercase mb-1">
                {social.name}
              </h3>
              <p className="text-black/50 text-sm font-mono truncate">
                {social.handle}
              </p>
              <div className="mt-3 flex items-center justify-center gap-1 text-sm font-mono uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-opacity" style={{ color: social.color }}>
                Follow <ExternalLink className="w-3 h-3" />
              </div>
            </motion.a>
          ))}
        </motion.div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="text-center mt-10"
        >
          <a
            href="https://voice-audition-app.preview.emergentagent.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-black text-white rounded-full px-8 py-4 font-mono text-sm uppercase tracking-widest hover:bg-black/80 transition-colors"
          >
            Submit Your Demo to Win R50,000
            <ExternalLink className="w-4 h-4 ml-2" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default SocialBanner;
